import countryList from "react-select-country-list";

const countryOptions = countryList().getData();

export function getCountryName(code = "") {
  if (!code) return "";

  const normalised = String(code).trim().toUpperCase();

  // Try matching ISO 3166-1 alpha-2 codes ("GB", "US", "FR")
  let match = countryOptions.find((c) => c.value.toUpperCase() === normalised);

  // Fallback: Veriff sometimes sends alpha-3 ("GBR", "USA")
  if (!match && normalised.length === 3) {
    match = countryOptions.find(
      (c) => c.value.toUpperCase() === normalised.slice(0, 2)
    );
  }

  return match ? match.label.toUpperCase() : code.toUpperCase();
}
